import React from 'react';
import { BadgeCheck } from 'lucide-react';

// 信頼性を高めるための控えめな公式エージェンシー認定バッジ
const TrustBadge = ({ className = '', variant = 'light' }) => {
  const palette = variant === 'dark'
    ? { bg: 'rgba(255,255,255,0.08)', color: '#FFFFFF', border: 'rgba(255,255,255,0.28)' }
    : { bg: '#FFF7FA', color: '#C77A93', border: '#F7C9D3' };

  return (
    <span
      data-testid="tiktok-trust-badge"
      className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-medium ${className}`}
      style={{ backgroundColor: palette.bg, color: palette.color, border: `1px solid ${palette.border}` }}
    >
      <BadgeCheck className="w-4 h-4 flex-shrink-0" />
      TikTok LIVE公認エージェンシー
    </span>
  );
};

export default TrustBadge;
